
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Shared/Shared.san?lang=less&san=&type=style&index=0');
require('./Shared.less?lang=less');
var injectStyles = [];

        var template = require('./Shared.html');
        
        var script = require('./Shared.ts').default;
        module.exports = require('./Shared.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    